import {
  registerLicense, L10n, setCulture, loadCldr
} from '@syncfusion/ej2-base';
import { Dictionary } from '@felicity/i18n';
import locale from './locale/locale.mjs';
import numbers from './locale/numbers.mjs';
import config from './config.json';

registerLicense(config.syncfusion.licenseKey);
setCulture(document.documentElement.getAttribute('lang'));
loadCldr(numbers);

L10n.load(locale);
window.i18n = {
  dictionary: new Dictionary(locale)
};
